// this file is used to make all spaces in the driver Card visible in the HTML
const formatWithAllSpaces = (string = '') => string.replace(
    / {2}/gu,
    '\u00a0\u00a0',
);

export default formatWithAllSpaces;
